/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, hexToRgba, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const card = css({
  borderBottomLeftRadius: 32,
  color: colorsPalette.black,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 460,
  position: 'relative',
  textDecoration: 'none',

  [MediaQueries.mdAndUp]: {
    height: '100%',
    maxWidth: 'none',
  },

  '&:hover': {
    boxShadow: shadows.shadow80,

    '.result-cards-info': {
      borderColor: colorsPalette.transparent,
    },
  },
});

export const isFeaturedTag = css(typography.effra12Link, {
  backgroundColor: colorsPalette.white,
  borderRadius: 2,
  fontWeight: fontWeights.medium,
  left: 16,
  lineHeight: 1.66,
  padding: '2px 6px',
  paddingTop: 3,
  position: 'absolute',
  textTransform: 'uppercase',
  top: 16,
  zIndex: 1,
});

export const pictureWrapper = css({
  overflow: 'hidden',
  paddingBottom: '56.25%', // Generates the "height" for the picture (16:9)
  position: 'relative',
});

export const picture = css({
  left: 0,
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  width: '100%',
});

export const image = css({
  display: 'block',
  width: '100%',
});

export const cardInfo = css({
  border: `1px solid ${hexToRgba(colorsPalette.brown40, 0.5)}`,
  borderBottomLeftRadius: 32,
  borderTop: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: 24,
  pointerEvents: 'none',
  [MediaQueries.mdAndUp]: {
    flex: '1 0 auto',
  },
});

export const titleAddress = css({
  marginBottom: 16,
});

export const cardTitle = css(typography.effra18, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
});

export const cardAddress = css(typography.effra14, {
  color: colorsPalette.grey60,
});

export const solutionsItemsWrapper = css({
  marginBottom: 16,
  minHeight: 72,

  [MediaQueries.lgAndUp]: {
    minHeight: 78,
  },
});

export const solutionItemName = css(typography.effra16, {
  color: colorsPalette.black,
  display: 'block',
});

export const solutionItemPrice = css(typography.effra16, {
  color: colorsPalette.teal,
  display: 'block',
});

export const footerData = css({
  marginTop: 'auto',
});

export const imageBrand = css({
  display: 'block',
  maxWidth: 95,
});

export const partnerTag = css({
  color: colorsPalette.grey40,
  display: 'block',
  fontSize: 10,
  marginTop: 2,
  textAlign: 'center',
  width: 95,
});
